import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/components/app/app.component';
import { appConfig } from './app/app.config';
import { ConfigService } from '@jms/ui/ui.standalone.services/config.service';

import { LicenseManager, provideGlobalGridOptions } from 'ag-grid-enterprise';

navigator.serviceWorker.register('/download-zip/files.zip.worker.js', { scope: '/download-zip/' });

// Cross-tab logout: redirect if auth_token removed in another tab
window.addEventListener('storage', (e) => {

    if (e.key === 'auth_token' && !e.newValue) {
        window.location.href = ConfigService.environment.jms.logoutHref;
    }
});

LicenseManager.setLicenseKey(ConfigService?.environment?.grid);
provideGlobalGridOptions({ theme: "legacy" });

if (ConfigService.environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, appConfig);
